import http from "@/axios";

class InterventionDashboard {
	async index(payload?:object): Promise<any> {
		return await http.get("/intervention-dashboard/index", { params: payload });
	}
}
export default new InterventionDashboard();
